export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mineral Processing Educator — London, United Kingdom',
    'My students finally understand the difference between crushing and grinding, particle separation, flotation processes, and mineral recovery fundamentals. I used to waste hours searching for the right way to explain how mineral processing actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain comminution circuits, gravity separation, magnetic separation, flotation chemistry, or how to teach technical reasoning in mineral processing contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Mineral Processing and Operations Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated mineral processing projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mineral Processing Educator | London, United Kingdom',
    "The material on comminution and flotation completely changed how my students understand mineral processing. They finally grasp how particle size and surface chemistry drive recovery. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Mineral Processing Teacher | Berlin, Germany',
    "The 50 mineral processing projects transformed how my students see real-world applications. Now they analyze plant circuits, understand separation methods, evaluate efficiency problems, and grasp why mineral processing knowledge matters professionally and in real mining operations. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The mineral processing terminology handbook gave me back my class time. I used to spend time explaining processing concepts and misconceptions. Now I show the handbook and students instantly understand mineral processing concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Mineral Processing Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real mineral processing challenges, evaluating circuit performance, exploring optimization scenarios, and understanding how technical reasoning contributes to resource efficiency and sustainability. This completely transformed how they see mineral processing.",
  ],
];
